import React, { useState, useEffect} from 'react';
import { Navbar, Nav, Container, Image, NavbarBrand } from 'react-bootstrap';
import styles from './navbar.module.css'
import logo from '../../assets/images/newlogo.png';
import ticket from '../../assets/images/ticket.svg';
const MainNavbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Navbar
      className={`${styles.navbar} ${scrolled ? styles.navbarScrolled : ''}`}
      expand="md"
      fixed="top"
      bg='dark'
    >
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav"   style={{backgroundColor: '#EF5BA1'}} />
        <NavbarBrand>
          <div className={styles.logoWrapper}>
            <a href="/">
            <Image href="/" src={logo} alt="Logo" className={`${styles.logo}`} />
            </a>
          </div>
        </NavbarBrand>
        <Navbar.Collapse  id="basic-navbar-nav" >
          <Nav className={`ms-auto ${styles.navbarNav}`}>
            <Nav.Link href="/games" className={styles.navLink}>
              معرفی بازی‌ها
            </Nav.Link>
            <Nav.Link href="/virtual" className={styles.navLink}>
              تور مجازی
            </Nav.Link>
            <Nav.Link
              href="/calculator"
              className={styles.navLink}
            >
              تعرفه‌
            </Nav.Link>
          </Nav>
          <Nav className={`me-auto ${styles.navbarNav}`}>
          <Nav.Link href="/birthday" className={styles.navLink}>
              اتاق تولد
            </Nav.Link>
            <Nav.Link href="/comingSoon" className={styles.navLink}>
              شعب
            </Nav.Link>
            <Nav.Link href="/login" className={styles.navLink}>
              <Image src={ticket} alt="Ticket" className={styles.ticket} />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MainNavbar;
